import { render } from "./gameMilestonesView.vue?vue&type=template&id=14de1b66&scoped=true"
import script from "./gameMilestonesView.vue?vue&type=script&lang=js"
export * from "./gameMilestonesView.vue?vue&type=script&lang=js"

import "./gameMilestonesView.vue?vue&type=style&index=0&id=14de1b66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14de1b66"]])

export default __exports__